import type { IImagesPanelStockCategory } from "./types";

export const STOCK_IMAGES_QUERY_KEYS = "stock-images-images-query";
export const IMAGES_PANEL_MASONRY_COLS = 3;
export const IMAGES_PANEL_MASONRY_GAPS = 8;

export const IMAGES_PANEL_MASONRY_FAKE_CELLS = 3;
export const IMAGES_PANEL_MASONRY_LOAD_SCROLL = 0.5;

export const IMAGES_PANEL_SKELETON_HEIGHTS = [
  [67, 76, 162],
  [127, 67, 162],
  [186, 67, 162],
];

export const IMAGES_PANEL_STOCK_CATEGORIES: IImagesPanelStockCategory[] = [
  {
    key: "ai_suggestions",
    label: "AI Suggestions",
    query: "",
  },
  {
    key: "business",
    query: "Business",
  },
  {
    key: "team",
    query: "Team",
  },
  {
    key: "invest",
    query: "Invest",
  },
  {
    key: "cyber",
    query: "Cyber",
  },
  {
    key: "sales",
    query: "Sales",
  },
  {
    key: "office",
    query: "Office",
  },
  {
    key: "urban",
    query: "Urban",
  },
  {
    key: "real_estate",
    query: "Real estate",
  },
  {
    key: "finance",
    query: "Finance",
  },
  {
    key: "e_commerce",
    query: "E-commerce",
  },
];
